// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-toast-area{bottom:0;display:flex;flex-direction:column;justify-content:flex-end;left:20px;pointer-events:none;position:fixed;z-index:11000}.mp-toast-area a{color:var(--inverted-component-text-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
